module.exports = __webpack_public_path__ + "img/cinema.a01ed8ac.jpg";